import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import {
  ANNOTATIONS_UNREAD_BADGE_ARIA,
  ANNOTATIONS_UNREAD_COUNT,
} from "../../../i18n/keysTranslations";

const ANNOTATION_UNREAD_DOT_COLOR = "#ef4444";

const AnnotationUnreadIndicator = ({ hasUnread, unreadCount, t }) => {
  if (!hasUnread) return null;

  const displayCount = unreadCount > 0 ? unreadCount : 1;
  const tooltipLabel =
    displayCount > 1
      ? t(ANNOTATIONS_UNREAD_COUNT, { count: displayCount })
      : t(ANNOTATIONS_UNREAD_BADGE_ARIA);

  return (
    <Tooltip title={tooltipLabel}>
      <Box
        component="span"
        role="status"
        aria-label={tooltipLabel}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          minWidth: 18,
          height: 18,
          px: displayCount > 9 ? 0.5 : 0,
          borderRadius: "50%",
          backgroundColor: ANNOTATION_UNREAD_DOT_COLOR,
          color: "#ffffff",
          fontSize: "10px",
          fontWeight: 700,
          lineHeight: 1,
          pt: 0.1,
        }}
      >
        {displayCount}
      </Box>
    </Tooltip>
  );
};

export default AnnotationUnreadIndicator;
